/**
 * ServiceSelectorFormat 常量定义
 */
import type { IFieldMappingConfig } from './types';

/**
 * 标记值，表示需要从 selector 中获取全部数据
 */
export const ALL_VALUE = '255';

/**
 * 预设的字段映射配置
 * @description 常用的字段映射配置，可以直接使用或作为参考
 */
export const PRESET_FIELD_MAPPINGS: Record<string, IFieldMappingConfig> = {
  // ua_network 级联筛选器 - 按 UA 类型过滤
  UA_NETWORK_BY_UA: {
    filterPath: 'custom_filters.ua_network',
    selectorPath: 'ua_network',
    cascadeConfig: {
      typeField: 'type',
      typeValue: 'UA',
      codeField: 'code'
    }
  },

  // ua_network 级联筛选器 - 按 network_type 类型过滤
  UA_NETWORK_BY_NETWORK_TYPE: {
    filterPath: 'custom_filters.network_type',
    selectorPath: 'ua_network',
    cascadeConfig: {
      typeField: 'type',
      typeValue: 'network_type',
      codeField: 'code'
    }
  },

  // zone_list 区域列表
  ZONE_LIST: {
    filterPath: 'zone_list',
    selectorPath: 'zone_list',
    extractor: (data: any[]) => data?.map((item) => item.zone_code).filter(Boolean) || []
  },

  // channel_list 渠道列表
  CHANNEL_LIST: {
    filterPath: 'channel_list',
    selectorPath: 'channel_list',
    extractor: (data: any[]) => data?.map((item) => item.channel_id).filter(Boolean) || []
  },

  // os_list 系统列表
  OS_LIST: {
    filterPath: 'os_list',
    selectorPath: 'os_list',
    extractor: (data: any[]) => data?.map((item) => item.os_id).filter(Boolean) || []
  },

  // lang_list 语言列表
  LANG_LIST: {
    filterPath: 'lang_list',
    selectorPath: 'lang_list',
    extractor: (data: any[]) => data?.map((item) => item.lang_code).filter(Boolean) || []
  },

  // market_list 市场列表（通常对应 country_list 或 area_list）
  MARKET_LIST: {
    filterPath: 'market_list',
    selectorPath: 'country_list',
    extractor: (data: any[]) => data?.map((item) => item.country_code).filter(Boolean) || []
  },

  // ad_format 广告格式
  AD_FORMAT: {
    filterPath: 'custom_filters.ad_format',
    selectorPath: 'ad_format',
    extractor: (data: any[]) => data?.map((item) => item.code).filter(Boolean) || []
  },

  // version 版本
  VERSION: {
    filterPath: 'custom_filters.version',
    selectorPath: 'version_list',
    extractor: (data: any[]) => data?.map((item) =>
      typeof item === 'string' ? item : item.version || item.code
    ).filter(Boolean) || []
  },

  // user_type 用户类型
  USER_TYPE: {
    filterPath: 'custom_filters.user_type',
    selectorPath: 'user_type_list',
    extractor: (data: any[]) => data?.map((item) =>
      typeof item === 'string' ? item : item.code || item.id
    ).filter(Boolean) || []
  },

  // campaign 广告活动
  CAMPAIGN: {
    filterPath: 'custom_filters.campaign',
    selectorPath: 'campaign_list',
    extractor: (data: any[]) => data?.map((item) =>
      typeof item === 'string' ? item : item.code || item.id
    ).filter(Boolean) || []
  }
};
